// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/shield-check.js';

import { paths } from '../generated/shield-check';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('shield-check', Original, paths);
